import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Steps } from 'primereact/steps';
import { confirmDialog } from 'primereact/confirmdialog';

import Header from '@components/Header';
import General from '@components/Profiles/General';
import Permission from '@components/Profiles/Permission';
import Accessibility from '@components/Profiles/Accessibility';
import JustificationModal from '@components/JustificationModal';

import { editProfile, getProfilesCatalog } from '@actions/profiles';
import { setCatalogCurrentProfiles } from '@actions/catalogs';
import { sendActionToBitacora  } from '@actions/bitacora';

import { CLEAR_VALUES_PROFILE, SET_VALUES_PROFILE } from '@constants/actionType'
import { LANGUAGE_DEFAULT } from '@constants/general'

import store from '@store'

class EditProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      maxStep:2,
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
      loadingPage: true
    }
  }

  async componentDidMount() {
    const { history } = this.props
    if (history.location.state?.clearCache) {
      await store.dispatch({
        type: CLEAR_VALUES_PROFILE,
      })
    }
    if (!history.location.state?.id) return history.push("/profiles")
    this.setDetailProfile(history.location.state)

    this.setState({loadingPage: false})
  }

  setDetailProfile = async (data) => {
    const { keysLenguages } = this.props
    const { id, nombre, permisos, secciones } = data

    const formatPermissions = permisos.map(item => item.id)
    let formatSections = []
    if (secciones.lista.length) formatSections = secciones.lista.map(item => item.id)
    const state = {
      general: {},
      permissionSelect: formatPermissions,
      accessibility: {
        navega: secciones.navega,
        sectionsSelected: formatSections,
      },
      id
    }
    keysLenguages.map((language) => {
      const getName = nombre[language] || ''
      state.general[language] = { name: getName }
    })
    await store.dispatch({
      type: SET_VALUES_PROFILE,
      payload: {
        ...state
      }
    })
    return true
  }

  nexStep = async () => {
    const { step } = this.state
    this.setState({ btnSubmitLoading: true });
    // if (step ===  2) return this.createLayouts()
    this.setState(prevState => ({maxStep: step + 1 > prevState.maxStep ? step + 1 : prevState.maxStep}))
    this.setState(prevState => ({step: prevState.step + 1}))
    this.setState({ btnSubmitLoading: false });
  }

  backStep = () => {
    this.setState({ btnSubmitLoading: true });
    this.setState(prevState => ({step: prevState.step - 1}))
    this.setState({ btnSubmitLoading: false });
  }

  validateOnchangeStep = (e) => {
    const { maxStep } = this.state
    if (e.index > maxStep) return true
    return this.setState({step: e.index}) 
  }

  onConfirmEditProfile = () => {
    const { t } = this.props;

    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => this.onEditProfile(justification),
      },
    });
  }

  onEditProfile = async (justification) => {
    const { editProfile, t, history, getProfilesCatalog, setCatalogCurrentProfiles, sendActionToBitacora, _general } = this.props
    this.setState({ btnSubmitLoading: false });
    const response = await editProfile(justification)
    if (!response.status) {
      const dataBitacora = {
        transactionName: 'actPerfil',
        reason: `${_general[LANGUAGE_DEFAULT].name} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await getProfilesCatalog({type: 'visible'})
      setCatalogCurrentProfiles()
      this.setState({ btnSubmitLoading: false });
      confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/profiles'),
        onHide: () => history.push('/profiles')
      });
      return store.dispatch({
        type: CLEAR_VALUES_PROFILE,
      })
    }
    return this.setState({ btnSubmitLoading: false });
  }

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  render () {
    const { t } = this.props
    const { step, btnSubmitLoading, loadingPage, showModalJustification } = this.state
    const steps = [
      { label: t("Datos generales"), command: (event) => { this.validateOnchangeStep(event) } },
      { label: t("Permisos"), command: (event) => { this.validateOnchangeStep(event) } },
      { label: t("Accesibilidad"), command: (event) => { this.validateOnchangeStep(event) } }
    ]

    const stepsRender = () => {
      if (step === 0) {
        return (
          <General
            success={this.nexStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (step === 1) {
        return (
          <Permission
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (step === 2) {
        return (
          <Accessibility
            success={this.onConfirmEditProfile}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
            isEdit
          />
        );
      }
    }

    if (loadingPage) return true
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t("Datos del Perfil")} linkText={t("Ir al listado")} to="/profiles" />
          <div className="card">
            <div className="p-grid p-mb-2">
              <div className="p-col-12 p-my-1">
                <Steps model={steps} activeIndex={step} readOnly={false}/>
              </div>
            </div>

            {stepsRender()}
          </div>
        </div>
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  keysLenguages: state.catalogs.keysLanguageCatalog,
  _general: state.profile.general
});


const mapDispatchToProps = {
  editProfile,
  getProfilesCatalog,
  setCatalogCurrentProfiles,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(EditProfile);
